import { secrets } from '@chilipiper/config'
import { store } from '@chilipiper/utils'
import { isCypress, isServiceWorker } from '@chilipiper/utils'
import { RoxSetupOptions } from 'rox-browser'
import Rox from './rollout-mock/rolloutMock'

export const isRolloutEnabled =
  !isCypress &&
  !isServiceWorker &&
  process.env.NODE_ENV !== 'development' &&
  !!secrets.rolloutApiKey

const mockRolloutFlags = {
  enableLiveChat: new Rox.Flag(true),
  enableDistributionWorkspace: new Rox.Flag(true),
  enableHandoff: new Rox.Flag(true),
  enableOpenRegistrationSeries: new Rox.Flag(false),
  enableSignature: new Rox.Flag(true),
  enableUTMTracking: new Rox.Flag(true),
  enableSingleUseLink: new Rox.Flag(true),
  enableAskTheGuest: new Rox.Flag(true),
  enableMeetingLocation: new Rox.Flag(true),
  newIbToggle: new Rox.Flag(true),
  enableMaintenance: new Rox.Flag(false),
  enableMeetingsGroupEvents: new Rox.Flag(false),
  enableReassignDropdown: new Rox.Flag(true),
  enableDashboardCancel: new Rox.Flag(true),
  enableHopinIntegration: new Rox.Flag(true),
  enableMsWithoutConsent: new Rox.Flag(false),
  enableRulesV2: new Rox.Flag(true),
  enableCrmRouterV2: new Rox.Flag(true),
  enableGongIntegration: new Rox.Flag(true),
  enableChilical: new Rox.Flag(true),
  enableExperimentalDarkMode: new Rox.Flag(true),
  enableRulesBuilder: new Rox.Flag(true),
  enableNewDistributionReport: new Rox.Flag(true),
  enableNewDistributionReportHistoryTab: new Rox.Flag(true),
  enableDistroCapping: new Rox.Flag(true),
  fireNavigation: new Rox.Flag(true),
  legacyLicensesUpsell: new Rox.Flag(true),
  fireLicensesUpsell: new Rox.Flag(true),
  inAppLicensesSell: new Rox.Flag(true),
  forceDisplayInvoiceFlow: new Rox.Flag(true),
  fireTeamsMigration: new Rox.Flag(true),
  enableAdminCenterSettings: new Rox.Flag(false),
  hubspotIntegrationUser: new Rox.Flag(false),
  fireCrmRouterDuplicationAllowed: new Rox.Flag(true),
  crmMatchingEnabled: new Rox.Flag(true),
  conciergeFireEnabled: new Rox.Flag(true),
  distroOnboarding: new Rox.Flag(true),
  fireAuth: new Rox.Flag(false),
  chilicalComingSoon: new Rox.Flag(false),
  conciergeComingSoon: new Rox.Flag(false),
  chatComingSoon: new Rox.Flag(false),
  chilicalPreviewModal: new Rox.Flag(false),
  conciergePreviewModal: new Rox.Flag(false),
  flowBuilderEnabled: new Rox.Flag(true),
  billingCenter: new Rox.Flag(true),
  chilicalOrgLicense: new Rox.Flag(true),
  fireHubspotIntegration: new Rox.Flag(true),
  conciergeLicense: new Rox.Flag(true),
  chatLicense: new Rox.Flag(true),
  createFlowBuilderDistro: new Rox.Flag(true),
  enableUserControls: new Rox.Flag(true),
  changeBillingPeriod: new Rox.Flag(true),
  switchToPayByInvoice: new Rox.Flag(true),
  cancelSubscription: new Rox.Flag(true),
  distroExecutionPreview: new Rox.Flag(true),
  conciergeLiteLicense: new Rox.Flag(true),
  gongIntegration: new Rox.Flag(true),
  createOrUpdateTrigger: new Rox.Flag(true),
  leadConversionAction: new Rox.Flag(true),
  createBankAccount: new Rox.Flag(true),
  upgradeTrials: new Rox.Flag(true),
  managerRoles: new Rox.Flag(true),
  notificationSettings: new Rox.Flag(true),
  addToCampaign: new Rox.Flag(true),
  distroOwnershipFieldsInUpdateOwnership: new Rox.Flag(true),
}

const defaultRolloutFlags: typeof mockRolloutFlags = {
  enableLiveChat: new Rox.Flag(false),
  enableDistributionWorkspace: new Rox.Flag(false),
  enableHandoff: new Rox.Flag(true),
  enableOpenRegistrationSeries: new Rox.Flag(false),
  enableSignature: new Rox.Flag(true),
  enableUTMTracking: new Rox.Flag(false),
  enableSingleUseLink: new Rox.Flag(false),
  enableAskTheGuest: new Rox.Flag(false),
  enableMeetingLocation: new Rox.Flag(false),
  newIbToggle: new Rox.Flag(false),
  enableMaintenance: new Rox.Flag(false),
  enableMeetingsGroupEvents: new Rox.Flag(false),
  enableReassignDropdown: new Rox.Flag(false),
  enableDashboardCancel: new Rox.Flag(false),
  enableHopinIntegration: new Rox.Flag(false),
  enableMsWithoutConsent: new Rox.Flag(false),
  enableRulesV2: new Rox.Flag(false),
  enableCrmRouterV2: new Rox.Flag(false),
  enableGongIntegration: new Rox.Flag(false),
  enableChilical: new Rox.Flag(false),
  enableExperimentalDarkMode: new Rox.Flag(false),
  enableRulesBuilder: new Rox.Flag(false),
  enableNewDistributionReport: new Rox.Flag(false),
  enableNewDistributionReportHistoryTab: new Rox.Flag(false),
  enableDistroCapping: new Rox.Flag(false),
  fireNavigation: new Rox.Flag(false),
  legacyLicensesUpsell: new Rox.Flag(false),
  fireLicensesUpsell: new Rox.Flag(false),
  inAppLicensesSell: new Rox.Flag(false),
  forceDisplayInvoiceFlow: new Rox.Flag(false),
  fireTeamsMigration: new Rox.Flag(false),
  enableAdminCenterSettings: new Rox.Flag(false),
  hubspotIntegrationUser: new Rox.Flag(false),
  fireCrmRouterDuplicationAllowed: new Rox.Flag(false),
  crmMatchingEnabled: new Rox.Flag(false),
  conciergeFireEnabled: new Rox.Flag(false),
  distroOnboarding: new Rox.Flag(false),
  fireAuth: new Rox.Flag(false),
  chilicalComingSoon: new Rox.Flag(false),
  conciergeComingSoon: new Rox.Flag(false),
  chatComingSoon: new Rox.Flag(false),
  chilicalPreviewModal: new Rox.Flag(false),
  conciergePreviewModal: new Rox.Flag(false),
  flowBuilderEnabled: new Rox.Flag(false),
  billingCenter: new Rox.Flag(false),
  chilicalOrgLicense: new Rox.Flag(false),
  fireHubspotIntegration: new Rox.Flag(false),
  conciergeLicense: new Rox.Flag(false),
  chatLicense: new Rox.Flag(false),
  createFlowBuilderDistro: new Rox.Flag(false),
  enableUserControls: new Rox.Flag(false),
  changeBillingPeriod: new Rox.Flag(false),
  switchToPayByInvoice: new Rox.Flag(false),
  cancelSubscription: new Rox.Flag(false),
  distroExecutionPreview: new Rox.Flag(false),
  conciergeLiteLicense: new Rox.Flag(false),
  gongIntegration: new Rox.Flag(false),
  createOrUpdateTrigger: new Rox.Flag(false),
  leadConversionAction: new Rox.Flag(false),
  createBankAccount: new Rox.Flag(false),
  upgradeTrials: new Rox.Flag(false),
  managerRoles: new Rox.Flag(false),
  notificationSettings: new Rox.Flag(false),
  addToCampaign: new Rox.Flag(false),
  distroOwnershipFieldsInUpdateOwnership: new Rox.Flag(true),
}

export const isFireAuth = () => rolloutFlags.fireAuth.isEnabled()

type Flags = Record<keyof typeof mockRolloutFlags, { isEnabled(): boolean }>
type MutableFlags = Record<keyof typeof mockRolloutFlags, FlagWrapper>

const rolloutInnerFlags = isRolloutEnabled ? defaultRolloutFlags : mockRolloutFlags

class FlagWrapper {
  private value: boolean

  constructor(initialValue: boolean) {
    this.value = initialValue
  }

  isEnabled = () => this.value

  setValue = (value: boolean) => {
    this.value = value
  }
}

const initFlags = (): MutableFlags =>
  Object.entries(rolloutInnerFlags).reduce<MutableFlags>((flags, [name, flag]) => {
    flags[name as keyof typeof mockRolloutFlags] = new FlagWrapper(flag.isEnabled())

    return flags
  }, {} as MutableFlags)

const updateFlags = () =>
  Object.entries(rolloutInnerFlags).forEach(([name, flag]) => {
    internalFlags[name as keyof typeof mockRolloutFlags].setValue(flag.isEnabled())
  })

const internalFlags = initFlags()

export const rolloutFlags: Flags = internalFlags

export const rolloutSetup = async (rolloutOptions: RoxSetupOptions, namespace = '') => {
  if (isRolloutEnabled) {
    Rox.setCustomStringProperty('hostname', window.location.hostname)

    Rox.register(namespace, rolloutInnerFlags)
    await Rox.setup(secrets.rolloutApiKey, rolloutOptions)
  }
}

export const ROLLOUT_EMAIL_LOCALSTORAGE_KEY = 'rollout-email'
export const ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY = 'rollout-tenantId'

export const setRolloutUser = (session: { email?: string; tenantId?: string }): void => {
  if (isRolloutEnabled) {
    if (!store.isFake()) {
      if (session.email) {
        localStorage.setItem(ROLLOUT_EMAIL_LOCALSTORAGE_KEY, session.email)
        Rox.setCustomStringProperty('email', session.email)
      }
      if (session.tenantId) {
        localStorage.setItem(ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY, session.tenantId)
        Rox.setCustomStringProperty('tenantId', session.tenantId)
      }
    }
    Rox.fetch()
  }
}

export type SetUserData = (_session: { email: string; tenantId: string }) => Promise<void>
/*
 * The idea with this approach was to promisify setting the user data
 * which is a pre-requisite to properly use any feature flag that relies on user data.
 * Basically, we dependency inject the callbackRef object inside of rolloutInit to
 * the asyncSetRolloutUserBuilder which in turn sets the resolve function to the callback
 * of the passed callbackRef object. Resolve function is called once the configurationFetchedHandler
 * is called signalling that the user data is successfully set.
 */
const asyncSetRolloutUserBuilder = (callbackRef: {
  callback: (_value: any) => unknown
}): SetUserData => {
  return (session: { email: string; tenantId: string }) =>
    new Promise(res => {
      callbackRef.callback = res
      setRolloutUser(session)
    })
}

const fetchRef = {
  status: '',
}

export const rolloutInit = async (appName: string): Promise<SetUserData> => {
  if (isRolloutEnabled) {
    const callbackRef = {
      callback: (_result: Rox.RoxFetcherResult) => {},
    }

    const options: RoxSetupOptions = {
      version: '1.2.0',
      configurationFetchedHandler: (fetcherResult: Rox.RoxFetcherResult) => {
        fetchRef.status = fetcherResult.fetcherStatus
        updateFlags()
        callbackRef.callback(fetcherResult)
      },
    }
    Rox.setCustomStringProperty('appName', appName)
    await rolloutSetup(options)

    // we have to get from localstorage because rollout saves only unique id for user
    if (!store.isFake()) {
      const userTenantIdCached = localStorage.getItem(ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY) || ''
      const userEmailCached = localStorage.getItem(ROLLOUT_EMAIL_LOCALSTORAGE_KEY) || ''
      setRolloutUser({ email: userEmailCached, tenantId: userTenantIdCached })
    }

    await new Promise(res => {
      const interval = setInterval(() => {
        if (fetchRef.status === 'APPLIED_FROM_NETWORK') {
          clearInterval(interval)
          res(undefined)
        }
      }, 100)
    })

    return asyncSetRolloutUserBuilder(callbackRef)
  }
  return () => Promise.resolve()
}
